"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var BaseController_1 = require("../../controllers/BaseController");
var UIUtils_1 = require("../../modules/UIUtils");
var DlgOpenFileCtl = /** @class */ (function (_super) {
    __extends(DlgOpenFileCtl, _super);
    function DlgOpenFileCtl() {
        return _super.call(this, true) || this;
    }
    DlgOpenFileCtl.prototype.ResetData = function () {
        this.DATA = {
            onReadFile: null,
            title: "",
            input: null
        };
    };
    DlgOpenFileCtl.prototype.readSingleFile = function (e) {
        var _this = this;
        var file = e.target.files[0];
        if (!file) {
            return;
        }
        if (file.size > 1024 * 1024 * 10) { //10 MB default max upload size
            return;
        }
        var _fileName = file.name;
        var reader = new FileReader();
        reader.onload = function (e) {
            var _content = e.target["result"];
            if (_this.DATA.onReadFile) {
                _this.DATA.onReadFile(_fileName, UIUtils_1.UIUtils.Base64Encode(_content));
            }
        };
        reader.readAsBinaryString(file);
    };
    DlgOpenFileCtl.prototype.Show = function () {
        if (!this.DATA.input) {
            this.DATA.input = document.createElement("input");
            this.DATA.input.setAttribute("type", "file");
            this.DATA.input.setAttribute("accept", "image/x-png,image/gif,image/jpeg");
            this.DATA.input.style.display = "none";
            this.DATA.input.onchange = this.readSingleFile.bind(this);
            document.body.appendChild(this.DATA.input);
        }
        this.DATA.input.setAttribute("title", this.DATA.title);
        this.DATA.input.click();
        this.Update();
        return this;
    };
    DlgOpenFileCtl.prototype.SetTitle = function (title) {
        this.DATA.title = title;
        this.Update();
        return this;
    };
    DlgOpenFileCtl.prototype.SetOnReadFile = function (callback) {
        this.DATA.onReadFile = callback;
        this.Update();
        return this;
    };
    return DlgOpenFileCtl;
}(BaseController_1.BaseController));
exports.DlgOpenFileCtl = DlgOpenFileCtl;



//////////////////
// WEBPACK FOOTER
// ./src/shared/dialogs/ctl/DlgOpenFileCtl.ts
// module id = 889
// module chunks = 0